// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import React, { useState } from 'react';
import { defaultMintLimit, defaultBurnLimit, LimitsContext } from './LimitsContext';

interface LimitsProviderProps {
  children: React.ReactNode;
}

export const LimitsProvider: React.FC<LimitsProviderProps> = ({ children }) => {
  const [mintLimit, setMintLimit] = useState(defaultMintLimit);
  const [burnLimit, setBurnLimit] = useState(defaultBurnLimit);

  return (
    <LimitsContext.Provider value={{ mintLimit, burnLimit, setMintLimit, setBurnLimit }}>
      {children}
    </LimitsContext.Provider>
  );
};
